document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    const submitBtn = document.getElementById("submitRFQForm");

    if (submitBtn) {
      submitBtn.addEventListener("click", function (event) {
        if (!submitBtn.classList.contains("disabled")) {
          /* Perform all actions here.. */

          const productTable = document.querySelector(".quote-table")?.innerHTML || "";

          const firstName = document.querySelector("#contact_info\\[first_name\\]")?.value || "";
          const lastName = document.querySelector("#contact_info\\[last_name\\]")?.value || "";
          const email = document.querySelector("#contact_info\\[email\\]")?.value || "";
          const phone = document.querySelector("input[type=tel]")?.value || "";
          const address = document.getElementById("text__1759297612260")?.value || "";
          const suburb = document.getElementById("text__1759297253536")?.value || "";
          const state = document.getElementById("select__1759297326016")?.value || "";
          const postcode = document.getElementById("text__1759297385644")?.value || "";
          const country = document.getElementById("select__1759297428386")?.value || "";
          const message = document.getElementById("message")?.value || "";
          const supplyInstall = document.querySelector("input[name='radio-group__1759297653034']:checked")?.value || "";
          const preferredStore = document.getElementById("select__1759295820816")?.value || "";

          const formData = {
            productTable,
            firstName,
            lastName,
            email,
            phone,
            address,
            suburb,
            state,
            postcode,
            country,
            message,
            supply_install: supplyInstall,
            preferredStore,
          };

          console.log("formData", formData);

          
        //   fetch("https://media365.com.au/tileboutique/index-tbnew.php", {
          fetch("https://media365.com.au/tileboutique/te-quote.php", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
          })
          .then(response => response.json())
          .then(data => {
            console.log("API Response"<data);
          })
          .catch(error => {
            console.error("Error:", error);
          });
          

        } else {
          console.log("Class exist.. wait!!");
        }

        // event.preventDefault();n
      });
    }
  }, 5000);
});
